import { Grid, GridProps, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PinPuk } from "./PinPuk";
import { IBroadbandSubscription, IMobileSubscription } from "@pages/AccountDetails/interface/IAccountDetailsPage";
import { CopyTextFieldIcon } from "@common/CopyTextField/CopyTextFieldIcon";

interface IParams {
    isMobileDomain: boolean;
    subscription: IMobileSubscription & IBroadbandSubscription;
}

export const ContractOfferDetails = (props: IParams) => {
    const {
        isMobileDomain,
        subscription: { activatedAt, simCard, uan },
    } = props;
    const { t } = useTranslation("accountDetails");
    const align: GridProps["textAlign"] = { xs: "left", sm: isMobileDomain ? "left" : "center" };

    return (
        <Grid columnSpacing={{ xs: 0, sm: 2 }} container rowSpacing={2} style={{ width: "auto" }}>
            <Grid item sm={isMobileDomain ? 3 : 4} textAlign={align} xs={6}>
                <Typography color="secondary" fontWeight="bold" variant="normal">
                    {t("contract")}:
                </Typography>
                <Typography color="secondary" variant="normal">
                    {t("contractLength")}
                </Typography>
            </Grid>
            <Grid item sm={isMobileDomain ? 3 : 4} textAlign={align} xs={6}>
                <Typography color="secondary" fontWeight="bold" variant="normal">
                    {t("startDate")}:
                </Typography>
                <Typography color="secondary" variant="normal">
                    {activatedAt}
                </Typography>
            </Grid>
            <Grid item sm={isMobileDomain ? 6 : 4} textAlign={align} xs={12}>
                {isMobileDomain ? (
                    simCard ? (
                        <PinPuk pinNumber={simCard.pin1Code} pukNumber={simCard.puk1Code} />
                    ) : (
                        <Typography variant="normal">{t("noActiveOfferForPhoneNumber")}</Typography>
                    )
                ) : (
                    <Stack alignItems="center" direction="row" justifyContent={align} spacing={3}>
                        <Stack>
                            <Typography color="secondary" fontWeight="bold" variant="normal">
                                {t("UAN")}:
                            </Typography>
                            <Typography color="secondary" variant="normal">
                                {uan}
                            </Typography>
                        </Stack>
                        <CopyTextFieldIcon textToCopy={uan ?? ""} />
                    </Stack>
                )}
            </Grid>
        </Grid>
    );
};
